export enum EStatusCuradoriaCadastro {
    Pendente = 1,
    Aprovado = 2,
    Reprovado = 3,
}
